import type { EmailPreviewBody, EmailPreviewParams } from '@lotta/shared/types-lottery-api';
import { apis } from './apis';

const previewEmailApis = apis.injectEndpoints({
  endpoints: (build) => ({
    previewEmail: build.mutation<unknown, EmailPreviewParams & EmailPreviewBody>({
      query: ({ retailUnit, emailContent }) => ({
        url: `/${retailUnit}/email-preview`,
        method: 'POST',
        body: { emailContent },
      }),
    }),
  }),
});

export const { usePreviewEmailMutation } = previewEmailApis;
